import React, { useRef, useState, useEffect } from 'react';
import './App.css';
import { supabase } from './config';
import { useNavigate } from 'react-router-dom';

function Tasky() {
  const [uuid, setuid] = useState('');
  const [state, setstate] = useState([]);
  const inpref = useRef(null);
  const navigate = useNavigate();

  
  useEffect(() => {
    supabase.auth.getUser().then((res) => {
      const userId = res.data?.user?.id;
      if (userId) {
        setuid(userId);
        fetchTasks(userId);
      } else {
        navigate('/Sign');
      }
    }).catch(() => {
      navigate('/Sign');
    });
  }, []);

  
  const fetchTasks = (userId) => {
    supabase
      .from('todo')
      .select('*')
      .eq('uid', userId)
      .then((res) => {
        setstate(res.data || []);
      });
  };

  
  const todo = () => {
    const val = inpref.current.value;
    if (val === '') {
      alert('Enter something');
      return;
    }
    for (const i of state) {
      if (val === i.task) {
        alert('Task already exists');
        return;
      }
    }

    supabase
      .from('todo')
      .insert([{ task: val, check: false, uid: uuid }])
      .then(() => {
        fetchTasks(uuid);
      });
  };

  // Delete all tasks
  const del = () => {
    supabase
      .from('todo')
      .delete()
      .neq('id', 0)
      .then(() => {
        fetchTasks(uuid);
      });
  };

  
  const toggleCheck = (obj) => {
    supabase
      .from('todo')
      .update({ check: !obj.check })
      .eq('id', obj.id)
      .then(() => {
        fetchTasks(uuid);
      });
  };

  return (
    <div className='App'>
      <h1>Tasky</h1>
      <input ref={inpref} className='inp' />
      <button onClick={todo} className='add'>Add</button>
      <button onClick={del} className='del'>Clear</button>

      {state.map((obj) => (
        <div className='container' key={obj.id}>
          <div className='row'>
            <input
              type='checkbox'
              checked={obj.check}
              onChange={() => toggleCheck(obj)}
              className='check'
            />
            <h3
              style={{ textDecoration: obj.check ? 'line-through' : 'none' }}
              className='txt'
            >
              {obj.task}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Tasky;